import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  actions: {
    initialiseStore(context) {
      if (localStorage.getItem('store')) {
        const store = JSON.parse(localStorage.getItem('store'));
        context.commit('auth/TOKEN_UPDATE', {
          accessToken: store.accessToken,
          refreshToken: store.refreshToken,
        });
      }
      if (localStorage.getItem('settings')) {
        const store = JSON.parse(localStorage.getItem('settings'));
        if (store.version === context.state.settings.version) {
          // eslint-disable-next-line
          context.state.settings = store;
        } else {
          localStorage.removeItem('settings');
          localStorage.setItem('settings', JSON.stringify(context.state.settings));
        }
      }
    },
  },
});
